import { GetStaticPropsResult } from 'next'
import React, { ReactElement } from 'react'
import privacyPolicyPageData from '@/content/privacy-policy.json'
import markdownToHtml from '@/utils/markdownToHtml'
import { formatDateAndMonth } from '@/utils/formatDate'
import {
  LegalPagesProps,
  BaseLegalPage,
} from '@/components/patterns/BaseLegalPage'

export async function getStaticProps(): Promise<
  GetStaticPropsResult<LegalPagesProps>
> {
  const htmlContent = await markdownToHtml(privacyPolicyPageData.body || '')

  return {
    props: {
      meta: {
        title: privacyPolicyPageData.title,
        description: '',
      },
      content: {
        title: privacyPolicyPageData.title,
        lastUpdate: formatDateAndMonth(privacyPolicyPageData.updatedAt),
        content: htmlContent,
      },
      cta: privacyPolicyPageData.cta,
    },
  }
}

export default function PrivacyPolicyPage({
  meta,
  content,
  cta,
}: LegalPagesProps): ReactElement {
  return <BaseLegalPage meta={meta} content={content} cta={cta} />
}
